module.exports = function() {
  return new Worker(__webpack_public_path__ + "66f9fa0db5a7ec9c1db8.worker.js");
};